import { BasePaginateResultSchema } from '@/api/common.ts'
import { z } from 'zod'

// Search Params Schema
export const ProblemPoSearchParamsSchema = z.object({
  fromDate: z.coerce.date().optional(),
  toDate: z.coerce.date().optional(),
  partyId: z.string().optional(),
  problems: z.array(z.string()).optional().default([]),
  pageNumber: z.number().optional().default(1),
  pageSize: z.number().optional().default(10000),
})

export type ProblemPoSearchParams = z.infer<typeof ProblemPoSearchParamsSchema>

/**
 * Tracking Po Item
 */
export const ProblemPoItemSearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  date: z.coerce.date(),
  latestExpectedDueDate: z.coerce.date(),
  poId: z.number().int(),
  poItemId: z.number().int().nullable(),
  itemId: z.number().int().nullable(),
  itemCode: z.string().nullable(),
  itemName: z.string().nullable(),
  qty: z.number().nullable(),
  outstanding: z.number().nullable(),
  partyId: z.number().int(),
  problem: z.string(),
  problemDate: z.coerce.date(),
})

export type ProblemPoItemSearchResultModel = z.infer<
  typeof ProblemPoItemSearchResultModelSchema
>

// Search Result Schema
export const ProblemPoItemSearchResultSchema = z
  .object({
    data: z.array(ProblemPoItemSearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type ProblemPoItemSearchResult = z.infer<
  typeof ProblemPoItemSearchResultSchema
>
